import {AsyncPipe} from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ReactiveFormsModule, UntypedFormArray, UntypedFormControl, Validators,} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {
    MatCard,
    MatCardActions,
    MatCardContent,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle,
} from '@angular/material/card';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {InvitationService} from '@app/invitation/invitation.service';
import {InvitesComponent} from '@app/invitation/invites/invites.component';

import {SetupState, SiteConfig, SiteConfigService} from '@app/shared/site-config.service';
import {StreamService} from '@app/stream/stream.service';

import {Observable} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';

@Component({
    selector: 'frog-setup',
    templateUrl: './setup.component.html',
    styleUrls: ['./setup.component.scss'],
    imports: [
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardSubtitle,
        MatCardContent,
        MatFormField,
        MatLabel,
        MatInput,
        ReactiveFormsModule,
        MatCardActions,
        MatButton,
        InvitesComponent,
        AsyncPipe,
    ],
})
export class SetupComponent implements OnInit {
    @ViewChild(InvitesComponent) invitationForm;

    public siteConfig$: Observable<SiteConfig>;
    public nameControl: UntypedFormControl;
    public streamControl: UntypedFormControl;
    public state: SetupState;
    public inviteRows: UntypedFormArray;
    public SetupState = SetupState;

    constructor(
        private siteConfigService: SiteConfigService,
        private streamService: StreamService,
        private invitationService: InvitationService,
    ) {
        this.nameControl = new UntypedFormControl('', Validators.required);
        this.streamControl = new UntypedFormControl('Main');
        this.inviteRows = new UntypedFormArray([new UntypedFormControl('')]);
    }

    ngOnInit(): void {
        this.siteConfig$ = this.siteConfigService.siteConfig.pipe(
            tap((siteConfig) => {
                this.state = siteConfig.data.setup || SetupState.Name;
                this.nameControl.setValue(siteConfig.data.name.replace('aaa', ''));
            }),
        );
    }

    next(siteConfig: SiteConfig) {
        const configData = Object.assign({}, siteConfig.data);
        switch (this.state) {
            case SetupState.Name:
                this.state = SetupState.Stream;
                configData.name = this.nameControl.value;
                configData.setup = this.state;
                this.siteConfigService.save(configData).subscribe();
                break;
            case SetupState.Stream:
                this.state = SetupState.Invites;
                this.streamService.updateStream(siteConfig.data.primary_stream, {
                    name: this.streamControl.value,
                });
                configData.setup = this.state;
                this.siteConfigService.save(configData).subscribe();
                break;
            case SetupState.Invites:
                const invitations = this.invitationForm.getInvitations();
                this.invitationService
                    .invite(siteConfig.client_id, invitations)
                    .pipe(
                        switchMap(() => {
                            configData.setup = SetupState.Complete;
                            return this.siteConfigService.save(configData);
                        }),
                    )
                    .subscribe();
                break;
        }
    }

    skipInvitations(siteConfig: SiteConfig) {
        const configData = Object.assign({}, siteConfig.data);
        configData.setup = SetupState.Complete;
        this.siteConfigService.save(configData).subscribe();
    }
}
